module.exports = __webpack_public_path__ + "assets/retina_HeronDetailed.384ba1a428e5ad9ee8cf8be782eee817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_HeronDetailed.png
// module id = 674
// module chunks = 0